import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';
import { CompanyCityModel } from '../../models/management/company-city.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyCityService {

  constructor(private _httpClient: HttpClient) { }

  createCompanyCity(companyCityModel: CompanyCityModel): Observable<CompanyCityModel> {
    return this._httpClient.post<CompanyCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.CreateCompanyCity}`,
      companyCityModel);
  }

  deleteCompanyCity(companyCityId: number): Observable<CompanyCityModel> {
    return this._httpClient.delete<CompanyCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.DeleteCompanyCity}/${companyCityId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllCompanyCity(): Observable<Array<CompanyCityModel>> {
    return this._httpClient.get<Array<CompanyCityModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.GetAllCompanyCity}`)
  }

  getAllCompanyCitiesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.GetAllCompanyCitiesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getCompanyCityById(companyCityId: number | null): Observable<CompanyCityModel> {
    return this._httpClient.get<CompanyCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.GetByIdAsync}/${companyCityId}`)
  }

  getCompanyCityByCityId(cityId: number | null): Observable<CompanyCityModel> {
    return this._httpClient.get<CompanyCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.GetCompanyCityByCityId}/${cityId}`)
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.GetColumnsForGeneralConsultationAsync}`);
  }

  updateCompanyCity(companyCityModel: CompanyCityModel): Observable<CompanyCityModel> {
    return this._httpClient.put<CompanyCityModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.companyCity.UpdateAsync}`,
      companyCityModel);
  }
}
